import { io } from "socket.io-client";
import Config from "./Config";
import { getCookie } from "./Utils";


let socketInstance = null;

const buildSocket = () => io(Config.URL.BACKEND_URL, {
    autoConnect: false,
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    auth: (callback) => callback({
        token: getCookie("token"),
        page: window.location?.pathname || "",
    }),
});

export const getSocket = () => {
    if (!socketInstance) socketInstance = buildSocket();
    return socketInstance;
};

export const connectSocket = () => {
    const socket = getSocket();
    if (!socket.connected) socket.connect();
    return socket;
};

export const disconnectSocket = () => {
    if (!socketInstance) return;
    if (socketInstance.connected) {
        try {
            socketInstance.emit("staff:offline");
        } catch (error) {

        }
    }
    socketInstance.disconnect();
};
